import styles from './Cards.module.sass'
import AffectioCard from "@/components/Cards/AffectioCard";
import {useEffect, useMemo, useRef, useState} from "react";
import {useGSAP} from "@gsap/react";
import gsap from "gsap";

const Cards = () => {
	const cards = useMemo(() => [
		{
			className: styles.cat,
			name: 'Le chat',
			level: 1,
			hearts: 7,
			cardNumber: '03/100',
			character: {
				className: styles.cat__character,
				src: '/images/Game/Cat/cat.gif',
				mobileSrc: '/images/Game/Cat/cat.png',
				alt: 'Cat gif',
				width: 70,
				height: 40,
			},
			background: {
				src: '/images/Cards/cat_background.png',
				alt: 'Cat background',
			},
			attacks: {
				firstAttack: 'Un chat féroce qui fait ses griffes partout dans les locaux d’AS (Clermont-Ferrand).',
				secondAttack: 'Lancez un dé, s’il est pair il attaque sinon il dort.',
				isSeparatedAttacks: false,
			}
		},
		{
			className: styles.sacha,
			name: 'Sacha',
			level: 2,
			hearts: 4,
			cardNumber: '02/100',
			character: {
				className: styles.sacha__character,
				src: '/Global/sacha_idleing.gif',
				mobileSrc: '/Global/sacha_idleing.png',
				alt: 'Sacha gif',
				width: 64,
				height: 64,
			},
			background: {
				src: '/images/Cards/sacha_background.png',
				alt: 'Sacha background',
			},
			attacks: {
				firstAttack: 'Machine à création : sa tête est toujours pleine d’idées pour son entreprise... Mais sont-elles viables ?',
				secondAttack: 'Piochez l’avocat dans votre deck',
				isSeparatedAttacks: false,
			}
		},
		{
			className: styles.lawyer,
			name: 'L\'avocat',
			level: 3,
			hearts: 7,
			cardNumber: '01/100',
			character: {
				className: styles.lawyer__character,
				src: '/images/Game/Lawyer/lawyer.gif',
				mobileSrc: '/images/Game/Lawyer/lawyer.png',
				alt: 'Lawyer gif',
				width: 64,
				height: 64,
			},
			background: {
				src: '/images/Cards/lawyer_background.png',
				alt: 'Lawyer background',
			},
			attacks: {
				firstAttack: 'Concentré sur le droit des affaires, le cabinet Affectio Societatis s\'adresse aux entrepreneurs·euses de tous secteurs d\'activités confondus.',
				secondAttack: 'Notre approche est basée sur l\'écoute de vos besoins afin de construire ensemble les solutions pertinentes pour vos projets.',
				isSeparatedAttacks: true,
			},
			objects: [
				{
					src: '/images/Game/Timeline/compass--stroke.png',
					alt: 'Compass',
				},
				{
					src: '/images/Game/Timeline/parchment--stroke.png',
					alt: 'Parchment',
				},
				{
					src: '/images/Game/Timeline/sword--stroke.png',
					alt: 'Sword',
				},
				{
					src: '/images/Game/Timeline/chest--stroke.png',
					alt: 'Chest',
				}
			]
		},
	])

	const [currentCardIndex, setCurrentCardIndex] = useState(1);
	const [pastCurrentCardIndex, setPastCurrentCardIndex] = useState(1)
	const cardAnimationTimelineRef = useRef()

	useEffect(() => {
		// Don't play the timeline if the card didn't change
		if(currentCardIndex !== pastCurrentCardIndex) {
			cardAnimationTimelineRef.current.play()
		}
	}, [currentCardIndex]);

	const getModuledIndex = (index) => {
		return (index + cards.length)  % cards.length
	}

	useGSAP(() => {
		cardAnimationTimelineRef.current = gsap.timeline({
			defaults: {
				duration: 1,
				ease: 'none',
			},
			paused: true,
			id: 'card_animation',
		})

		cardAnimationTimelineRef.current.timeScale(2.5)

		const previousIndex = getModuledIndex(pastCurrentCardIndex - 1)
		const currentIndex = getModuledIndex(pastCurrentCardIndex)
		const nextIndex = getModuledIndex(pastCurrentCardIndex + 1)


		// When we click on the left card, the diference is -2 or 1, otherwise if it's right it's 2 or -1
		const leftCardClicked = pastCurrentCardIndex - currentCardIndex === -2 || pastCurrentCardIndex - currentCardIndex === 1

		setPastCurrentCardIndex(currentCardIndex)

		// Get all cards
		const cards = document.querySelectorAll('.gsap-cards')

		if(leftCardClicked) {
			cardAnimationTimelineRef.current
				.to(cards[currentIndex], {
					'--before_opacity': 1,
					'--after_opacity': 0,
					transform: 'translate(0, -50%) scale(.9) rotate(15deg)',
					zIndex: 1,
				}, '<')
				.to(cards[previousIndex], {
					transform: 'translate(-150%, -50%) scale(.9) rotate(-7deg)',
					zIndex: 5,
					duration: .5
				}, '<')
				.to(cards[nextIndex], {
					'--before_opacity': 1,
					'--after_opacity': 0,
					transform: 'translate(-100%, -50%) scale(.9) rotate(-15deg)',
					zIndex: 0,
				}, '<')
				.to(cards[previousIndex], {
					'--before_opacity': 0,
					'--after_opacity': .15,
					transform: 'translate(-50%, -50%) scale(1) rotate(0deg)',
					duration: .5,
					delay: .5,
				}, '<')
				.call(() => {
					// Set the cursors to pointer for the currentIndex and nextIndex by adding the class 'custom_pointer'
					cards[previousIndex].classList.remove('custom_pointer')
					cards[currentIndex].classList.add('custom_pointer')
					cards[nextIndex].classList.add('custom_pointer')

					// Add the class basic_pointer to the previousIndex
					cards[previousIndex].classList.add('basic_pointer')
					setIsSwipeEnabled(true);
				})
		} else {
			cardAnimationTimelineRef.current
					.to(cards[currentIndex], {
						'--before_opacity': 1,
						'--after_opacity': 0,
						transform: 'translate(-100%, -50%) scale(.9) rotate(-15deg)',
						zIndex: 1,
					}, '<')
					.to(cards[nextIndex], {
						transform: 'translate(50%, -50%) scale(.9) rotate(7deg)',
						zIndex: 5,
						duration: .5,
					}, '<')
					.to(cards[previousIndex], {
						'--before_opacity': 1,
						'--after_opacity': 0,
						transform: 'translate(0%, -50%) scale(.9) rotate(15deg)',
						zIndex: 0,
					}, '<')
					.to(cards[nextIndex], {
						'--before_opacity': 0,
						'--after_opacity': .15,
						transform: 'translate(-50%, -50%) scale(1) rotate(0deg)',
						duration: .5,
						delay: .5,
					}, '<')
					.call(() => {
						// Set the cursors to pointer for the currentIndex and previousIndex by adding the class 'custom_pointer'
						cards[nextIndex].classList.remove('custom_pointer')
						cards[currentIndex].classList.add('custom_pointer')
						cards[previousIndex].classList.add('custom_pointer')

						// Add the class basic_pointer to the nextIndex
						cards[nextIndex].classList.add('basic_pointer')
						setIsSwipeEnabled(true);
					})
		}
		}, [currentCardIndex])


	// region Touch Handling
	const minSwipeDistance = 50
	const [touchStart, setTouchStart] = useState(0);
	const [touchEnd, setTouchEnd] = useState(null)
	const [isSwipeEnabled, setIsSwipeEnabled] = useState(true);

	const handleTouchStart = (e) => {
		setTouchEnd(null)
		setTouchStart(e.touches[0].clientX)
	};

	const handleTouchMove = (e) => {
		setTouchEnd(e.targetTouches[0].clientX)
	};

	const handleTouchEnd = () => {
		if (!touchStart || !touchEnd || !isSwipeEnabled) return
		const distance = touchStart - touchEnd
		const isLeftSwipe = distance > minSwipeDistance
		const isRightSwipe = distance < -minSwipeDistance
		if (isLeftSwipe || isRightSwipe) isLeftSwipe ? swipe('left') : swipe('right')
}


	const swipe = (direction) => {
		setIsSwipeEnabled(false);

		if(direction === 'right') {
			setCurrentCardIndex(getModuledIndex(currentCardIndex - 1))
		} else if(direction === 'left'){
			setCurrentCardIndex(getModuledIndex(currentCardIndex + 1))
		}
	};
	// endregion Swiping Handling


	return (
			<section id={'cards'}>
				<div className={styles.cards}
				     onTouchStart={handleTouchStart}
				     onTouchMove={handleTouchMove}
				     onTouchEnd={handleTouchEnd}
				>
				{cards.map((card, index) => {
					return(
							<AffectioCard
									key={index}
									cardIndex={index}
									card={card}
									className={styles.card}
									currentCardIndex={currentCardIndex}
									setCurrentCardIndex={setCurrentCardIndex}
							/>
					)
				})}
				</div>
		</section>
	)
}
export default Cards;